module.exports = __webpack_public_path__ + "img/total-today.2cde135b.svg";